import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { takeUntil, startWith, map } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ScrumboardService } from '../../scrumboard.service';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { ScrumboardCardDialogComponent } from 'app/main/pages/scrumboard/board/dialogs/card/card.component';
import { Card } from 'app/main/pages/scrumboard/card.model';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ExcelService } from '../../excel.service';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import * as moment from 'moment';

@Component({
  selector: 'app-sprint',
  templateUrl: './sprint.component.html',
  styleUrls: ['./sprint.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})

export class SprintComponent implements OnInit {

  cars = [{
    vin: 1434,
    brand: 'Audi',
    color: 'Black',
    year: 2019
  }];
  board: any;
  dialogRef: any;
  // Private
  private _unsubscribeAll: Subject<any>;
  empRole: any;
  superAccess: boolean = false;
  allowAccess: boolean;
  projectId: any;
  closedCount: any;
  totalCount: any;
  back = false;
  projectName: any;
  boardId: any;
  activeSprintLink: any;
  workItemsLink: any;
  sprintLink: any;
  projectMembers = [];
  taskForm: FormGroup;
  sprintForm: FormGroup;
  labelList = [];
  assignedResources = [];
  role = [];
  attachments = [];
  accodionData = [];
  backlogResult = [];
  filteredOptions: Observable<any[]>;
  myControl = new FormControl();
  projects: any[] = [];
  projectDetails: any[] = [];
  selectedProject: any = { name: '', id: '' };
  assigneeId = [];
  priorityValue = [];
  typeOfTaskValue = [];
  projectResults: any;
  cols: any[];
  title: any;
  sections = [];
  backlogCount: number;
  source = [];
  sprintList = [];
  backlogBoardListId: any;
  updateTaskId: any;
  listOfTaskType: [];
  currentUser: any;
  backlogBoardId: any;
  items = Array.from({ length: 100000 }).map((_, i) => `Item #${i}`);
  showFilter: any;
  matMenuSprintList = [];
  nextSprint: any;
  listOfSprints = [];
  excelData = [];
  rowData = [];
  sprintCount: any;
  listOfSprintIds = [];
  newSprintCreateDate: any;
  @ViewChild("sprintPopup", { static: false }) sprintPopup: TemplateRef<any>;
  currentHeaderName: string;
  totalRecords = 0;
  skipValue: number;
  searchedTitle = '';
  searchType: string;
  tenantId = '';

  constructor(
    private router: Router,
    private _location: Location,
    private _scrumboardService: ScrumboardService,
    private storageConfiguration: StorageConfiguration,
    private route: ActivatedRoute,
    private parseService: ParseService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private ref: ChangeDetectorRef,
    private hardCodedValues: HardCodedValues,
    private queryInterface: QueryInterface,
    private excelService: ExcelService,
    private activityCenterService: ActivityCenterService

  ) {
    this._unsubscribeAll = new Subject();
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.currentUser = this.parseService.instance.User.current();

    this.taskForm = this.formBuilder.group({
      title: ['', Validators.required],
      startDate: ['', Validators.required],
      dueDate: ['', Validators.required],
      description: ['', Validators.required],
      taskType: [''],
      assignee: [''],
      taskRole: [''],
      comments: [''],
      commentsText: [''],
      typeOfTask: ['']
    });

    this.sprintForm = this.formBuilder.group({
      sprintName: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      sprintGoal: ['', Validators.required]
    });

    this.cols = [
      { field: 'position', header: 'Position' },
      { field: 'title', header: 'Title' },
      { field: 'priority', header: 'Priority' },
      { field: 'assignee', header: 'Assignees' },
      { field: 'edit', header: 'Change Status' }
    ];
  }

  async ngOnInit() {

    this.route.params.subscribe(async params => {
      this.projectId = params.boardId;
      this.projectName = params.boardUri;
      this.getBoardLists();
      this.getEmployees(this.projectId);
      this.getRoles(this.projectId);
      this.getProMembers(this.projectId);
      this.getSprintList();
    });

    await this.getBacklogId();
    await this.getBacklogTasks().then(async res => {
      this.spinner.show();
      await this._scrumboardService.getBoard(this.backlogBoardId, 'inActive');
      this.spinner.hide();
    });

    this._scrumboardService.onBoardChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(board => {
      this.board = board;
    });
    this.getLabels();
    this.getProjectDropdown();

    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        this.boardId = results[0].id;
      }
    });
    this.getProjectResults();
    if (this.projectId != undefined && this.projectId != '') {
      this.back = true;
    }
    else {
      this.back = false;
    }

    let url = this.router.url.split('/');
    if (url[3] == 'sprint') {
      this.currentHeaderName = 'Backlogs';
    }
    if (url[3] == 'analytics') {
      this.currentHeaderName = 'Analytics';
      this.back = true;
    }
    if (url[3] == 'sprint-dashboard') {
      this.currentHeaderName = 'Sprint Dashboard';
    }
    if (url[3] == 'reports') {
      this.currentHeaderName = 'Reports';
    }
    if (url[3] == 'sprint-list') {
      this.currentHeaderName = 'Sprints';
    }
    if (url[1] == 'scrumboard' && url[2] == 'boards') {
      this.currentHeaderName = 'Active Sprint';
    }

  }

  async getBacklogId() {
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    query.equalTo('name', 'Backlogs');
    let results = await query.find();
    this.backlogBoardId = results[0].id;
  }

  async getProjectResults() {
    let projectqueryInstance = this.parseService.instance.Object.extend('Project');
    let projectquery = new this.parseService.instance.Query(projectqueryInstance);
    projectquery.equalTo('objectId', this.projectId);
    projectquery.equalTo('tenantId', this.tenantId);
    await projectquery.find().then(results => {
      this.projectResults = results[0];
    });
  }

  async getBacklogTasks() {
    this.spinner.show();
    let i = 0;
    this.backlogResult = [];
    let array = [];
    this.excelData = [];
    let listOfTask = [];
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('Project');
    query.equalTo('Project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    query.include('sprintId');
    query.equalTo('sprintId', { __type: 'Pointer', className: 'Sprint', objectId: this.backlogBoardId });
    query.limit(10);
    query.withCount();
    query.descending('updatedAt');
    if (this.skipValue != undefined) {
      query.skip(this.skipValue);
    }
    if (this.searchedTitle != '') {
      if (this.searchType == 'String') {
        query.contains('title', this.searchedTitle);
      }
      if (this.searchType == 'Number') {
        query.equalTo('cardNumber', Number(this.searchedTitle));
      }
    }
    if (this.priorityValue.length > 0) {
      query.containedIn('priority', [this.priorityValue]);
    }
    if (this.typeOfTaskValue.length > 0) {
      query.containedIn('typeOfTask', [this.typeOfTaskValue]);
    }
    if (this.assigneeId.length > 0) {
      query.containedIn('assigneesId', this.assigneeId);
    }
    let taskResult = await query.find();
    this.totalRecords = taskResult.count;
    for (const res of taskResult.results) {
      let assignee = await this.getAssignees(res.get('assignee'));
      let assignees = [];
      assignee.forEach(res => {
        assignees.push(res.name);
      });
      i = i + 1;
      array.push({
        position: i,
        id: res.id,
        title: res.get('title'),
        // priority: res.get('taskType'),
        priority: res.get('priority'),
        typeOfTask: res.get('typeOfTask'),
        assignee: assignee,
        cardNumber: res.get('cardNumber'),
        updatedAt: res.get('updatedAt'),
        createdAt: res.get('createdAt'),
        taskRole: res.get('taskRole'),
        estimatedHours: this.secondsToHms(res.get('estimatedHours')),
      });
      this.excelData.push({
        'Serial No': i,
        'Title': res.get('title'),
        // 'Priority': res.get('taskType').slice(-1)[0],
        'Priority': res.get('priority'),
        'Type Of Task': res.get('typeOfTask').slice(-1)[0],
        'Card Number': res.get('cardNumber'),
        'Task Role': res.get('taskRole').slice(-1)[0],
        'Estimated Hours': this.secondsToHms(res.get('estimatedHours')),
        'Assignees': assignees.join()
      });
    }
    listOfTask = array.filter((x, i, a) => a.indexOf(x) == i);
    this.backlogResult = listOfTask.sort((a, b) => {
      if ((a.updatedAt).getTime() > (b.updatedAt).getTime()) { return -1; }
      if ((a.updatedAt).getTime() < (b.updatedAt).getTime()) { return 1; }
    });
    // this.backlogResult = this.backlogResult.sort((n1, n2) => n1.position - n2.position);
    this.backlogCount = this.backlogResult.length;
    this.ref.markForCheck();
    this.spinner.hide();
  }

  nextPage(event) {
    let pageNumber = event.pageIndex + 1;
    let value = pageNumber * 10;
    this.skipValue = value - 10;
    this.getBacklogTasks();
  }

  async getSprintList() {
    this.sprintList = [];
    this.matMenuSprintList = [];
    this.listOfSprintIds = [];

    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    await query.find().then(results => {
      this.sprintCount = results.length;
      this.sprintCount = results.length;
      let lastSprint = this.sprintCount - 1;
      let lastSprintName = 'Sprint' + ' ' + lastSprint;
      results.forEach(element => {
        this.listOfSprintIds.push(element.id)
        if (element.get('name') != 'Backlogs') {
          this.sprintList.push({
            sprintName: element.get('name'),
            sprintId: element.id,
            status: element.get('status'),
            createdAt: element.get('createdAt'),
            startDate: element.get('startDate'),
            endDate: element.get('endDate'),
          });
          if (lastSprintName == element.get('name')) {
            let endDate = element.get('endDate');
            this.newSprintCreateDate = new Date(endDate.getTime() + 86400000);
          }
          this.matMenuSprintList = this.sprintList.filter(x => x.status != 'Closed');
        }
      });

      this.listOfSprints = this.sprintList.sort((a, b) => {
        if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return -1; }
        if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return 1; }
      });
      this.nextSprint = this.listOfSprints.slice(-1).pop();

    });
  }

  getToday(): any {
    return new Date(this.nextSprint != undefined ? this.nextSprint.endDate : new Date());
  }

  async getBoardLists() {
    let queryInstance = this.parseService.instance.Object.extend('ProjectBoardLists');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('name', 'Backlogs');
    await query.find().then(results => {
      this.backlogBoardListId = results[0].id
    });
  }

  deleteTask(event) {
    let taskId = event;
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', event);
    query.find().then(async results => {
      results[0].destroy().then(async (result) => {
        this.toastr.success('Task deleted successfully');
        await this.getBacklogTasks();
        this.deleteUserPlannedTask(taskId);
      });
    });
  }

  async deleteUserPlannedTask(taskId) {
    let userPlannedClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    let deleteOldRecords = new this.parseService.instance.Query(userPlannedClass);
    deleteOldRecords.equalTo('taskId', {
      __type: 'Pointer',
      className: 'Tasks',
      objectId: taskId
    });
    deleteOldRecords.limit(100);
    let queryResult = await deleteOldRecords.find();
    if (queryResult.length > 0) {
      this.parseService.instance.Object.destroyAll(queryResult);
    }
  }

  async checkEstimatedHours(taskId) {
    let estimatedHours;
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('sprintId');
    query.equalTo('objectId', taskId);
    await query.find().then(res => {
      let taskResults = res[0];
      estimatedHours = taskResults.get('estimatedHours');
    });
    return estimatedHours;
  }

  async updateScrumboard(scrumboardId, status) {
    let ProjectBoardLists = this.parseService.instance.Object.extend('ProjectBoardLists');
    let projectBoardLists = new this.parseService.instance.Query(ProjectBoardLists);
    projectBoardLists.equalTo('objectId', scrumboardId);
    let resultPro = await projectBoardLists.find();
    let profileDetail = resultPro[0];
    profileDetail.set('name', status);
    profileDetail.save();
  }

  async moveTask(event, taskId) {
    let Tasks = this.parseService.instance.Object.extend('Tasks');
    let tasks = new this.parseService.instance.Query(Tasks);
    tasks.equalTo('objectId', taskId);
    let res = await tasks.find();
    let taskDetails = res[0];

    if (taskDetails.get('userPlannedStatus') == "completed") {
      let scrumboardId = taskDetails.get('scrumboardList').id;
      await this.updateScrumboard(scrumboardId, 'Completed')
    }
    else if (taskDetails.get('userPlannedStatus') == "in-progress") {
      let scrumboardId = taskDetails.get('scrumboardList').id;
      await this.updateScrumboard(scrumboardId, 'In-Progress')
    }

    await this.checkEstimatedHours(taskId).then(async data => {
      if (data > 0) {
        let toDoResult;
        let newSprintName;
        this.taskRelationRemove(event, taskId);
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', event);
        let res = await query.find();
        let sprintResult = res[0];
        newSprintName = res[0].get('name');
        let value = await sprintResult.relation('BoardLists').query().find();
        toDoResult = value.filter(x => x.get('name') == 'To Do');
        let toDo = toDoResult[0];
        let queryProfile = new this.parseService.instance.Object('Tasks');
        queryProfile.id = taskId;
        await this.sprintPointerAdd(queryProfile.id, event);
        await this.toDoRelation(queryProfile, toDo.id);
        await this.toDoPointerAdd(queryProfile.id, toDo.id);

        /**
        * Card Activities
        */
        let taskUpdatedTime = queryProfile.get('taskUpdatedTime');
        taskUpdatedTime.todoDate = new Date().toISOString();
        queryProfile.set('taskUpdatedTime', taskUpdatedTime);
        let todoDateActivity = queryProfile.get('todoDateActivity');
        let movedCount = 0;
        movedCount = todoDateActivity.length > 0 ? todoDateActivity[todoDateActivity.length - 1].movedCount : movedCount;
        todoDateActivity.push({ date: taskUpdatedTime.todoDate, movedCount: movedCount + 1 })
        queryProfile.set('todoDateActivity', todoDateActivity);
        /**
        * Card Activities
        */

        let estimatedHours = queryProfile.get('estimatedHours');
        let storyPoints = queryProfile.get('storyPoints');
        storyPoints = storyPoints != '' ? Number(storyPoints) : 0;

        /**
         * Chart Data starts
         */
        let chartData = sprintResult.get('chartData');
        let status = sprintResult.get('status');
        let cardType = queryProfile.get('cardType');
        cardType = status == 'Active' ? 'UnPlanned' : 'Planned';
        queryProfile.set('cardType', cardType);
        if (status == 'New' && cardType == 'Planned') {
          chartData.storyPoints.planned.total = chartData.storyPoints.planned.total + storyPoints;
          chartData.tasks.planned.total = chartData.tasks.planned.total + 1;
          chartData.hours.planned.total = chartData.hours.planned.total + estimatedHours;
          chartData.storyPoints.planned.remaining = chartData.storyPoints.planned.remaining + storyPoints;
          chartData.tasks.planned.remaining = chartData.tasks.planned.remaining + 1;
        }
        if (status == 'Active' && cardType == 'UnPlanned') {
          chartData.storyPoints.unPlanned.total = chartData.storyPoints.unPlanned.total + storyPoints;
          chartData.tasks.unPlanned.total = chartData.tasks.unPlanned.total + 1;
          chartData.hours.unPlanned.total = chartData.hours.unPlanned.total + estimatedHours;
          chartData.storyPoints.unPlanned.remaining = chartData.storyPoints.unPlanned.remaining + storyPoints;
          chartData.tasks.unPlanned.remaining = chartData.tasks.unPlanned.remaining + 1;
        }
        let queryRes = await queryProfile.save();
        sprintResult.set('chartData', chartData);
        /**
       * Chart Data ends
       */
        let relation = sprintResult.relation('tasks');
        relation.add(queryProfile);
        let finalRes = await sprintResult.save();
        await this.getBacklogTasks();
        this.toastr.success('Task moved successfully');

        let activities = [];
        let message = 'Card Number' + ' ' + queryProfile.get('cardNumber') + ' ' + 'Moved from backlogs to' + ' ' + newSprintName;
        let activity = this.activityCenterService.setActivityModel(message);
        activities.push(activity);
        this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, sprintResult.id);

      }
      else {
        this.toastr.info('Please enter the estimated hours!!!')
      }
    });
  }

  toDoRelation(task, toDoId) {
    if (toDoId) {
      var queryRel = new this.parseService.instance.Query('ProjectBoardLists');
      queryRel.equalTo('objectId', toDoId);
      queryRel.first().then(function (res) {
        var relation = res.relation('Tasks');
        relation.add(task);
        res.save().then((result) => {
        });
        return res;
      });
    }
  }

  sprintPointerAdd(taskId, sprintId) {
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('sprintId');
    query.equalTo('objectId', taskId);
    query.find().then(res => {
      let result = res[0];
      result.set('sprintId', { __type: 'Pointer', className: 'Sprint', objectId: sprintId });
      result.save().then(result => {
      });
    });
  }

  toDoPointerAdd(taskId, toDoId) {
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('scrumboardList');
    query.equalTo('objectId', taskId);
    query.find().then(res => {
      let result = res[0];
      result.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: toDoId })
      result.save().then(result => {
      });
    });
  }

  taskRelationRemove(event, taskId) {
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('name', 'Backlogs');
    query.find().then(res => {
      let result = res[0];
      var queryProfile = new this.parseService.instance.Object('Tasks');
      queryProfile.id = taskId;
      var relation = result.relation('tasks');
      relation.remove(queryProfile);
      result.save().then(async (result) => {
        await this.getBacklogTasks();
      });
    });
  }

  async taskRelation(tasks) {
    await tasks.query().each(innerElement => {
      return innerElement;
    })
  }

  async getProMembers(projectId) {
    await this._scrumboardService.getProjectMembers(projectId).then(async results => {
      results.forEach(element => {
        this.projectMembers.push({
          profileId: element.get('user').get('profile').id,
          userName: element.get('user').get('profile').get('firstName') + ' ' + element.get('user').get('profile').get('lastName'),
          userImage: element.get('user').get('profile').get('profileImageInfo').url,
        })
      });
    });
  }

  async getRoles(projectId) {
    this.role = [];
    let array = [];
    let queryInstance = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', projectId);
    query.equalTo('tenantId', this.tenantId);
    query.find().then(results => {
      results.forEach(element => {
        let resource = element.get('resourceDetails');
        let resourceRole = resource.details
        resourceRole.forEach(innerElement => {
          array.push({
            id: this.getRandomNumber(9),
            taskRole: innerElement.role
          });
        });
      });
      this.role = array.filter((x, i, a) => a.indexOf(x) == i);
    });
  }

  getRandomNumber(val) {
    let timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split("").reverse();
    var id = "";
    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  async getEmployees(projectId) {
    this.assignedResources = [];
    let array = [];
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.include('user');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: projectId
    });
    query.equalTo('status', 'Assigned');
    query.find().then(results => {
      results.forEach(element => {
        let user = element.get('user');
        let profile = user.get('profile');
        let profileImage = profile.get('profileImageInfo') !== undefined ? profile.get('profileImageInfo').url : profile.get('profileImageInfo');
        let profileid = profile.id;
        let resourceName = element.get('username');
        let role = element.get('role');
        array.push({
          id: profileid,
          resourceName: resourceName,
          image: profileImage
        });
        this.assignedResources = array.filter((x, i, a) => a.indexOf(x) == i);
      });
    });
  }

  async getLabels() {
    this.labelList = [];
    this.listOfTaskType = [];
    await this._scrumboardService.getLabels().then(async res => {
      let result = res[0];
      this.labelList = result.get('taskType');
      this.listOfTaskType = result.get('typeOfTask');
    });
  }

  async createSprint(status) {
    if (this.sprintForm.valid) {
      let sprintFormValue = this.sprintForm.value;
      await this._scrumboardService.createScrumboardSprint(this.projectResults, sprintFormValue, status).then(async res => {
        this.dialog.closeAll();
        await this.getSprintList();

        let activities = [];
        let message = 'Created a Sprint ';
        let activity = this.activityCenterService.setActivityModel(message);
        activities.push(activity);
        this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, res.id);

        this.sprintForm.reset();
      });
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  addAttachments(event) {
    let size = event.target.files[0].size;
    let fileSize = Math.round(size / 1024)
    const file = event.target.files[0];
    if (file.type != 'application/pdf' && file.type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      && file.type != 'application/msword' && file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      && file.type != 'application/vnd.ms-excel' && file.type != "image/jpeg" && file.type != "image/jpg" && file.type != "text/plain") {
      this.toastr.warning('Please upload Document, excel, image and Pdf files only');
    }
    else if (fileSize <= 500) {
      var formData = new FormData();
      if (event.target.files.length > 0) {
        this.spinner.show();
        const file = event.target.files[0];
        formData.append('files', file);
        var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
        axios.post('https://corev2.whatsdare.com/file-api/api/v1/media', formData, {
          headers: {
            'authorization': 'Bearer r:275fc76ef2168814a16b37a759eb538c',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(aresf => {
          var test = aresf;
          let name = test.data.url.split('/');
          this.attachments = [];
          this.attachments.push({
            id: test.data._id,
            url: test.data.url,
            time: new Date(),
            name: name[4],
            type: test.data.type
          });
          this.spinner.hide();
        });
      }
    }
    else if (fileSize > 500) {
      this.toastr.warning('Please upload the file less than 500kb');
    }
  }

  async saveNewTask() {
    if (this.title != '' && this.title != undefined) {
      await this._scrumboardService.getBoard(this.backlogBoardId, 'inActive').then(async res => {
        const createrProfile = this.currentUser.get('profile');
        const createrImg = createrProfile.get('profileImageInfo').url;
        const createrName = createrProfile.get('username');
        let activities = [];
        const activity = {
          message: 'Created a Task',
          createdBy: createrName,
          createdId: createrProfile.id,
          createdDate: new Date().toUTCString(),
          createrImgUrl: createrImg === undefined ? this.hardCodedValues.defaultProfileImg : createrImg
        };
        activities.push(activity);
        this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, this.backlogBoardId);
        await this._scrumboardService.saveBacklogTask(this.backlogBoardListId, new Card({ name: this.title, activities: activities }), this.board).then(async res => {
          await this.getBacklogTasks();
          this.title = '';

          this.dialogRef = this.dialog.open(ScrumboardCardDialogComponent, {
            panelClass: 'scrumboard-card-dialog',
            width: '1200px',
            data: {
              cardId: res.id,
              listId: this.backlogBoardListId,
              activeStatus: 'New'
            }
          });
          this.dialogRef.afterClosed().subscribe(async response => {
            await this.getBacklogTasks().then(async res => {
              this.spinner.show();
              await this._scrumboardService.getBoard(this.backlogBoardId, 'inActive');
              this.spinner.hide();
            });
          });
        });
      });
    }
    else {
      this.toastr.warning('Please enter a task title');
      this.stopPropagation(event);
    }
  }

  /**
    * Open card dialog
    *
    * @param cardId
    */
  async editCardDialog(cardId): Promise<void> {
    this.dialogRef = this.dialog.open(ScrumboardCardDialogComponent, {
      panelClass: 'scrumboard-card-dialog',
      width: '1200px',
      data: {
        cardId: cardId,
        listId: this.backlogBoardListId,
        activeStatus: 'New'
      }
    });
    this.dialogRef.afterClosed().subscribe(async response => {
      await this.getBacklogTasks().then(async res => {
        this.spinner.show();
        await this._scrumboardService.getBoard(this.backlogBoardId, 'inActive');
        this.spinner.hide();
      });
    });
  }

  typeCheck(number): string {
    return (number == Number(number)) ? "Number" : "String"
  }

  async searchTask(event): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.backlogResult = [];
      if (event != undefined && event != '') {
        this.searchType = this.typeCheck(event);
        this.searchedTitle = event;
        this.getBacklogTasks();
      }
      else {
        this.searchedTitle = '';
        this.getBacklogTasks();
      }
    });
  }

  async commonFilter() {
    this.getBacklogTasks();
  }


  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.excelData, 'Backlogs');
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay;
  }

  async getRelations(result) {
    var relationResult = [];
    await result.query().each(function (obj) {
      relationResult.push(obj);
    });
    return relationResult;
  }

  async getAssignees(tasks) {
    let assignee = [];
    await tasks.query().each(innerElement => {
      assignee.push({
        name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
        profileId: innerElement.id,
        profilePic: innerElement.get('profileImageInfo').url
      });
    });
    return assignee;
  }

  async searchProject() {
    this.router.navigate(['/scrumboard/board/sprint/' + this.selectedProject.id + '/' + this.selectedProject.name]);
    this.projectId = this.selectedProject.id;

    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        let project = results[0].get('project').get('projectInfo');
        this.projectName = project.projectName;
        this.boardId = results[0].id;
        if (this.boardId != undefined) {
          this.activeSprintLink = '/scrumboard/boards/' + this.boardId + '/' + this.selectedProject.name;
        }
        else {
          this.toastr.warning('There is no active sprint');
        }
      }
    });
    this.getBoardLists();
    await this.getBacklogId();
    await this.getBacklogTasks().then(async res => {
      await this._scrumboardService.getBoard(this.backlogBoardId, 'inActive');
    });

  }

  getProjectDropdown(): void {
    let condition = [];
    let type = '';
    condition = [
      { field: 'objectId', condition: 'descending' },
      { condition: 'include', value: 'client' },
      { condition: 'limit', value: 10000 },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      // { condition: 'equalTo', field: 'projectType', value: 'Project' },
      { condition: 'containedIn', field: 'projectInfo.currentStatus', value: ['New', 'In Progress'] },
    ];
    type = 'Project';
    this.projectList(type, condition);
  }

  projectList(type, condition): void {
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      this.projects = [];
      this.projectDetails = [];
      results.forEach(async element => {
        await this.checkSprint(element.id).then(result => {
          if (result.length > 0) {
            this.projects.push({ id: element.id, name: element.get('projectInfo').projectName + ' - ' + element.get('projectType') });
            this.projectDetails.push({ id: element.id, name: element.get('projectInfo').projectName, projectInfo: element.get('projectInfo') });
          }
        });
        this.projects = this.projects.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
        this.getFilteredValue();
      });
    });
  }

  checkSprint(projectId): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let queryInstance = this.parseService.instance.Object.extend('Sprint');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('project', {
        __type: 'Pointer',
        className: 'Project',
        objectId: projectId
      });
      await query.find().then(res => {
        resolve(res);
      });
    });
  }

  getFilteredValue() {
    if (this.projects.length > 0) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(skillSets => this._filter(skillSets))
      );
    }
  }

  private _filter(value: string): any[] {
    let projects = JSON.stringify(this.projects);
    let projectList = JSON.parse(projects);
    const filterValue = value.toLowerCase();
    return projectList.filter(option => option.name
      .toString()
      .toLowerCase()
      .includes(filterValue)
    );
  }

  sprintDashboard() {
    this.router.navigate(['/scrumboard/board/sprint-dashboard/' + this.projectId + '/' + this.projectName]);
  }

  backlogsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/sprint/' + this.projectId + '/' + this.projectName]);
  }

  WorkLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/work-items/' + this.projectId + '/' + this.projectName]);
  }

  sprintsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/sprint-list/' + this.projectId + '/' + this.projectName]);
  }

  analyticsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/analytics/' + this.projectId + '/' + this.projectName]);
  }

  reportsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/reports/' + this.projectId + '/' + this.projectName]);
  }

  async activeSprint() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        let project = results[0].get('project').get('projectInfo');
        this.projectName = project.projectName;
        this.boardId = results[0].id;
        this.router.navigate(['/scrumboard/boards/' + this.boardId + '/' + this.projectName]);
      }
      else {
        this.toastr.warning('There is no active sprint');
      }
    });
  }

  /**
    * On destroy
    */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  /**
   * On board name changed
   *
   * @param newName
   */
  onBoardNameChanged(newName): void {
    this._scrumboardService.updateBoard();
    this._location.go('/pages/scrumboard/boards/' + this.board.id + '/' + this.board.uri);
  }

  /**
   * On drop
   *
   * @param ev
   */
  onDrop(ev): void {
    this._scrumboardService.updateBoard();
  }

  backToMyTaskPage = () => {
    this.router.navigate(['/on-going-project-list']);
  }

  backlocation() {
    this.router.navigate(['on-going-project-list']);
  }

  sprintconfirmPopup() {
    this.dialog.open(this.sprintPopup, {
      width: "500px"
    });
    this.sprintForm.patchValue({
      sprintName: 'Phase' + ' ' + this.sprintCount,
      startDate: moment(this.newSprintCreateDate)
    });
  }

  close() {
    this.dialog.closeAll();
  }

}
